import React, { FC, useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '..';

interface AuthRuteProps {
	children?: JSX.Element;
	exact?: boolean;
	path?: string;
	nonOuth?: boolean;
}

const AuthRoute: FC<AuthRuteProps> = ({ children, exact, path, nonOuth }) => {
	const { isLoggedIn, user } = useContext(AuthContext);
	const shouldRoute = nonOuth ? !isLoggedIn : isLoggedIn;

	if (shouldRoute) {
		return (
			<Route exact={exact} path={path}>
				{(nonOuth || user) && children}
			</Route>
		);
	}
	return <Redirect to='/login' />;
};

export { AuthRoute };
